import React, { useEffect, useState } from "react";
import "./category.styles.scss";
import { Space, Divider, Tooltip, UploadFile } from "antd";
import { ColumnType } from "antd/lib/table";
import CTable from "../../components/table/CTable";
import { QUERY_PARAM } from "../../constants/get-api.constant";
import { useSelectorRoot, useDispatchRoot } from "../../redux/store";
import Utils from "../../utils/base-utils";
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { Form, Input, Select, Upload, Button } from "antd";
import { motion } from "framer-motion";
import Modal from "antd/lib/modal/Modal";
import { API_URL } from "../../enums/api.enums";
import { ICategory } from "../../common/category.interface";
import { addCategoryRequest, deleteCategoryRequest, getListAuthorsRequest, getListCategoriesRequest } from "../../redux/controller";
import CModalEditCategory from "../../components/modal/CModalEditCategory";




const Category = () => {

    const Option = Select;
    const { categories, totalCategoriesRecords } = useSelectorRoot((state) => state.management);
    const [textSearch, setTextSearch] = useState("");
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [currentSearchValue, setCurrentSearchValue] =
        useState<any>({
            size: QUERY_PARAM.size,
            offset: 0,
        });
    const dispatch = useDispatchRoot();
    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);
    const [newCategory, setNewCategory] = useState<any>()
    const [category, setCategory] = useState()

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };

        window.addEventListener("resize", handleWindowResize);
        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    });

    useEffect(() => {
        dispatch(getListCategoriesRequest(currentSearchValue));
    }, []);

    const columns: ColumnType<ICategory>[] = [
        {
            title: "Số thứ tự",
            render: (_, __, rowIndex) => (
                <div className="span-table" style={{ textAlign: "center" }}>
                    {currentSearchValue.offset + rowIndex + 1}
                </div>
            ),
            width: "120px",
        },
        {
            title: "Tên thể loại",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Mô tả",
            dataIndex: "description",
            key: "description",
            render: (description) => (
                <div style={{ maxWidth: "200px" }}>
                    {description || "Chưa có mô tả"}
                </div>
            ),
        },
        {
            title: "Thời gian tạo",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ textAlign: "center" }} >{new Date(record.createdAt).toLocaleDateString("en-GB")}</div>
                </div>
            ),
        },
        {
            title: "Thao tác",
            key: "action",
            render: (_, record) => (
                <Space size="middle" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Tooltip placement="top" title={"Chỉnh sửa"} >
                        <EditOutlined onClick={(event) => handleEdit(record)} />
                    </Tooltip>
                    <Tooltip placement="top" title={"Xóa"}>
                        <DeleteOutlined onClick={(event) => handleDelete(record)} />
                    </Tooltip>

                </Space>
            ),
        },
    ];

    const onChangePagination = (event: any) => {
        currentSearchValue.offset = (event - 1) * QUERY_PARAM.size;
        setCurrentSearchValue(currentSearchValue);
        dispatch(getListCategoriesRequest(currentSearchValue));
    };

    const onChangeInput = (event: any) => {
        setTextSearch(event.target.value);
    };

    const onSearch = () => {
        const body: any = {
            size: QUERY_PARAM.size,
            offset: 0,
            search: textSearch,
        };
        const finalBody = Utils.getRidOfUnusedProperties(body);
        setCurrentSearchValue(finalBody);
        dispatch(getListCategoriesRequest(finalBody));
    };

    const onCancelAdd = () => {
        setOpenModalAdd(false)
        setNewCategory(null)
    }

    const handleChange = (event: { target: { value: any } }) => {
        setNewCategory(event.target.value);
    };

    const onAdd = (values: any) => {
        console.log('Adding category with values:', values);
        const bodyRequest = {
            name: values.name,
            description: values.description || undefined,
        }
        dispatch(addCategoryRequest(bodyRequest))
        setOpenModalAdd(false)
    }

    const handleEdit = (record: any) => {
        const selected: any = {
            id: record.id,
            name: record.name,
            description: record.description,
        }
        setCategory(selected)
        setOpenModalEdit(true);
    };

    const handleDelete = (record: any) => {
        const bodyRequest = {
            id: record.id,
        }
        dispatch(deleteCategoryRequest(bodyRequest))
    };

    const createSampleCategories = () => {
        const sampleCategories = [
            { name: "Văn học thiếu nhi", description: "Sách dành cho trẻ em và thiếu niên" },
            { name: "Tiểu thuyết", description: "Các tác phẩm tiểu thuyết trong và ngoài nước" },
            { name: "Khoa học - Công nghệ", description: "Sách về khoa học, công nghệ và kỹ thuật" },
            { name: "Kinh tế - Quản lý", description: "Sách về kinh tế, quản lý doanh nghiệp" },
            { name: "Tâm lý - Kỹ năng sống", description: "Sách phát triển bản thân và kỹ năng sống" },
            { name: "Lịch sử - Địa lý", description: "Sách về lịch sử, địa lý và văn hóa" },
            { name: "Nghệ thuật - Giải trí", description: "Âm nhạc, hội họa, thể thao" },
            { name: "Y học - Sức khỏe", description: "Kiến thức y khoa và chăm sóc sức khỏe" },
            { name: "Triết học - Tôn giáo", description: "Các tác phẩm triết học và tôn giáo" },
            { name: "Giáo dục - Học thuật", description: "Sách giáo khoa và tài liệu học tập" },
            { name: "Nấu ăn - Ẩm thực", description: "Công thức nấu ăn và văn hóa ẩm thực" },
            { name: "Du lịch - Khám phá", description: "Cẩm nang du lịch và khám phá thế giới" },
            { name: "Thể thao - Thể hình", description: "Kiến thức về thể thao và rèn luyện thân thể" },
            { name: "Công nghệ thông tin", description: "Lập trình, AI, và công nghệ số" },
            { name: "Ngoại ngữ", description: "Học tiếng Anh, tiếng Nhật và các ngôn ngữ khác" },
            { name: "Luật pháp", description: "Kiến thức pháp luật và quy định" },
            { name: "Nông nghiệp - Thủy sản", description: "Kỹ thuật canh tác và nuôi trồng" },
            { name: "Chính trị - Xã hội", description: "Các vấn đề chính trị và xã hội đương đại" },
            { name: "Môi trường - Sinh thái", description: "Bảo vệ môi trường và phát triển bền vững" },
            { name: "Đời sống - Gia đình", description: "Kinh nghiệm sống và quản lý gia đình" }
        ];

        // Tạo từng category một cách tuần tự
        sampleCategories.forEach((category, index) => {
            setTimeout(() => {
                dispatch(addCategoryRequest(category));
            }, index * 500); // Delay 500ms giữa mỗi request để tránh quá tải
        });
    };

    return (
        <motion.div
            className="sketch-main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            {openModalAdd && (
                <Modal
                    open={openModalAdd}
                    onOk={() => setOpenModalAdd(false)}
                    closable={true}
                    onCancel={onCancelAdd}
                    title={"Thêm thể loại"}
                    className="modal-add"
                    footer={false}
                    width={500}>
                    <Form
                        onFinish={onAdd}
                        layout="vertical"
                    >
                        <Form.Item 
                            label="Tên thể loại" 
                            name="name"
                            rules={[{ required: true, message: 'Vui lòng nhập tên thể loại' }]}
                        >
                            <Input placeholder="Nhập tên thể loại" />
                        </Form.Item>
                        
                        <Form.Item 
                            label="Mô tả thể loại" 
                            name="description"
                        >
                            <Input.TextArea 
                                placeholder="Nhập mô tả thể loại (tùy chọn)"
                                rows={3}
                                maxLength={200}
                                showCount
                            />
                        </Form.Item>
                        
                        <Form.Item
                            style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}
                        >
                            <Button type="primary" htmlType="submit">Thêm thể loại</Button>
                        </Form.Item>
                    </Form>
                </Modal>
            )}
            {openModalEdit &&
                <CModalEditCategory
                open={openModalEdit}
                data={category}
                setOpenModalEdit={setOpenModalEdit}
            />
            }
            {/* <div className="category-actions">
                <Button 
                    type="default" 
                    onClick={createSampleCategories}
                    className="sample-categories-btn"
                    style={{ 
                        marginBottom: '16px',
                        background: 'linear-gradient(135deg, #ff6b6b, #ff8e53)',
                        border: 'none',
                        color: 'white',
                        fontWeight: '600',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(255, 107, 107, 0.3)',
                        height: '40px'
                    }}
                >
                    🎯 Tạo 20 thể loại mẫu
                </Button>
            </div> */}
            
            <div className="table-area">
                <CTable
                    tableMainTitle="Danh sách thể loại"
                    allowTextSearch={false}
                    onChangeInput={onChangeInput}
                    onSearch={onSearch}
                    titleOfColumnList={columns}
                    data={categories}
                    totalRecord={totalCategoriesRecords}
                    titleAddButton="Thêm thể loại"
                    textSearch="Tên thể loại"
                    onChangePagination={onChangePagination}
                    allowAddObject={true}
                    pageSize={10}
                    size={450}
                    handleAddObject={() => setOpenModalAdd(true)}
                />
            </div>
        </motion.div>
    );
};

export default Category;
